import _default from './AutoSizer';
export { _default as default };
import _AutoSizer from './AutoSizer';
export { _AutoSizer as AutoSizer };


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/AutoSizer/index.js
// module id = 2095
// module chunks = 0